const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })

/**
 * Compare strings so embedded numbers order numerically:
 * "Chamber 2" before "Chamber 10", not after it.
 */
export function naturalCompare(a, b) {
  return collator.compare(a ?? '', b ?? '')
}

export function naturalSortBy(items, key) {
  return [...items].sort((a, b) => naturalCompare(key(a), key(b)))
}
